<template>
  <!-- Reset Component -->
  <v-container>
    <parameter ref="param" @error="onError" @id="onId"></parameter>
  </v-container>
</template>

<script>
import paramCtrl from "@/components/controls/parameter";
import settingsService from "@/_services/settings-service";

export default {
  components: {
    "parameter": paramCtrl,
  },

  mounted() {
    const data = {
      cancelUrl: settingsService.get("cancelUrl"),
      returnUrl: settingsService.get("loginUrl"),
      process: "reset",
    };
    this.$refs.param.create(data);
  },

  methods: {
    onId(id) {
      window.location.href = settingsService.get("remoteResetUrl") + id; 
    },

    onError(error) {
      console.log(error);
    }
  }

}
</script>

<style>

</style>